import styles from "./Button.module.css";
import React from "react";

function Button({ children, onClick, type, disabled, id, isSubmit = true }) {
  return (
    <button
      type={isSubmit ? "submit" : "button"}
      id={id}
      onClick={onClick}
      className={`${styles.btn} ${styles[type]} ${disabled ? styles.disabled : ""}`}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export default Button;
